<template>
  <div>
    <main-header />
    <iframe
      class="tables-v2-iframe"
      :src="tablesV2Url"
      title="Database Tables V2"
      frameborder="0" />
  </div>
</template>

<script lang="ts">
import config from '@/config'

export default {
  computed: {
    tablesV2Url () {
      const base = (config.get_FRONTEND_V2_URL() || '').replace(/\/+$/, '')
      const token = this.$store.state.auth.token
      return `${base}/#/tables-window?token=${encodeURIComponent(token)}`
    }
  }
}
</script>

<style>
.tables-v2-iframe {
  width: 100%;
  height: calc(100vh - 60px);
  border: 0;
  display: block;
}
</style>
